import { AxiosPromise } from 'axios';

import { pulseCheck, reportingApi } from '../../../../services/ApiController';
import { AsyncAction } from '../../../../services/apiMiddleware';
import { SurveySummaryResp } from '../interfaces/surveySummary.interface';
import { QuestionResponse } from '../../interfaces/questions.interface';
import { NewsResponse } from '../../interfaces/news.interface';
import { TopicsResponse } from '../../interfaces/topics.interface';
import { AnswerResponse } from '../../interfaces/answer.interface';
import { ParticipantsResponse } from '../../interfaces/participants.interface';
import { SessionUserI } from '../../../../interfaces/session.types';
import { ReportsObj } from '../../interfaces/header.interface';

export const SURVEY_PROFILE_ANY_REQUEST = 'SURVEY_PROFILE_ANY_REQUEST';
export const SURVEY_PROFILE_ANY_FAILED = 'SURVEY_PROFILE_ANY_FAILED';
export const GET_SURVEY_SUMMARY_SUCCESS = 'GET_SURVEY_SUMMARY_SUCCESS';
export const GET_SURVEY_NEWS_SUCCESS = 'GET_SURVEY_NEWS_SUCCESS';
export const GET_SURVEY_TOPICS_SUCCESS = 'GET_SURVEY_TOPICS_SUCCESS';
export const GET_SURVEY_QUESTIONS_SUCCESS = 'GET_SURVEY_QUESTIONS_SUCCESS';
export const GET_SURVEY_ANSWERS_SUCCESS = 'GET_SURVEY_ANSWERS_SUCCESS';
export const GET_SURVEY_PARTICIPANTS_SUCCESS = 'GET_SURVEY_PARTICIPANTS_SUCCESS';

export const getSurveySummary = (id: string, params?: string): AsyncAction<SurveySummaryResp> => ({
  types: [SURVEY_PROFILE_ANY_REQUEST, GET_SURVEY_SUMMARY_SUCCESS, SURVEY_PROFILE_ANY_FAILED],
  callAPI: () => reportingApi.get(`/reports/survey/${id}/summary?showSelfAssessments=${params}`),
});

export const getSurveyNews = (
  id: string,
  subject: ReportsObj,
  me: SessionUserI,
  params?: string,
): AsyncAction<NewsResponse> => {
  let surveyRoute = 'company';
  if (subject.surveyScope && subject.surveyScope !== 'admin') {
    surveyRoute = `user/${me.uuid}`;
  }
  return {
    types: [SURVEY_PROFILE_ANY_REQUEST, GET_SURVEY_NEWS_SUCCESS, SURVEY_PROFILE_ANY_FAILED],
    callAPI: () => reportingApi.get(`/reports/${surveyRoute}/survey/${id}/news?${params}`),
  };
};

export const getSurveyTopics = (
  query: string = '',
  subject: ReportsObj,
  me: SessionUserI,
): AsyncAction<TopicsResponse> => {
  let surveyRoute = 'company';
  if (subject.surveyScope && subject.surveyScope !== 'admin') {
    surveyRoute = `user/${me.uuid}`;
  }
  return {
    types: [SURVEY_PROFILE_ANY_REQUEST, GET_SURVEY_TOPICS_SUCCESS, SURVEY_PROFILE_ANY_FAILED],
    callAPI: () => reportingApi.get(`/reports/${surveyRoute}/survey/${subject.id}/topics${query}`),
  };
};

export const getSurveyParticipantsList = (
  id: string,
  subject: ReportsObj,
  me: SessionUserI | null,
  query: string = '',
): AsyncAction<ParticipantsResponse> => {
  let surveyRoute = 'company';
  if (me && subject.surveyScope && subject.surveyScope !== 'admin') {
    surveyRoute = `user/${me.uuid}`;
  }
  return {
    types: [SURVEY_PROFILE_ANY_REQUEST, GET_SURVEY_PARTICIPANTS_SUCCESS, SURVEY_PROFILE_ANY_FAILED],
    callAPI: () => reportingApi.get(`/reports/${surveyRoute}/survey/${id}/participants${query}`),
  };
};

export const getSurveyQuestionsList = (
  surveyId: string,
  topicId: string,
  query = '',
  subject: ReportsObj,
  me: SessionUserI,
): AsyncAction<QuestionResponse> => {
  let surveyRoute = 'company';
  if (subject.surveyScope && subject.surveyScope !== 'admin') {
    surveyRoute = `user/${me.uuid}`;
  }
  return {
    types: [SURVEY_PROFILE_ANY_REQUEST, GET_SURVEY_QUESTIONS_SUCCESS, SURVEY_PROFILE_ANY_FAILED],
    callAPI: () =>
      reportingApi.get(`/reports/${surveyRoute}/survey/${surveyId}/topic/${topicId}/questions${query}`),
  };
};

export const getSurveyQuestionAnswers = (
  surveyId: string,
  questionId: string,
  subject: ReportsObj,
  me: SessionUserI,
  query = '',
): AsyncAction<AnswerResponse> => {
  let surveyRoute = 'company';
  if (subject.surveyScope && subject.surveyScope !== 'admin') {
    surveyRoute = `user/${me.uuid}`;
  }
  return {
    types: [SURVEY_PROFILE_ANY_REQUEST, GET_SURVEY_ANSWERS_SUCCESS, SURVEY_PROFILE_ANY_FAILED],
    callAPI: () =>
      reportingApi.get(`/reports/${surveyRoute}/survey/${surveyId}/question/${questionId}/answers${query}`),
  };
};

export interface SentMailResp {
  triggered_mails: number;
}

export const sendMailFromPulseCheck = (encrString: string, cycleId: string): AxiosPromise<SentMailResp> =>
  pulseCheck.post(`/cycles/${cycleId}/mails`, { email_trigger: encrString });

export const sendStartMail = (cycleId: string): AxiosPromise<SentMailResp> =>
  pulseCheck.post(`/cycles/${cycleId}/mails/start`);
